import { render, staticRenderFns } from "./editAccount.vue?vue&type=template&id=16356b4a&scoped=true&"
import script from "./editAccount.vue?vue&type=script&lang=js&"
export * from "./editAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16356b4a",
  null
  
)

export default component.exports